
<template>
  <!--设备基础数据-->
  <div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="basic_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="true"
    >
    </x-tabula>
  </div>
</template>

<script>
export default {
  name: 'device',
  data () {
    return {
      searchList: [
        { props: ['keywords'], placeholder: '产品名称、型号', inputType: 'input' },
        { props: ['device_sncode'], placeholder: '设备编码', options: [], inputType: 'input' },
        { props: ['production_batch'], placeholder: '批次号', options: [], inputType: 'input' },
        { props: ['hardware_version'], placeholder: '硬件版本号', options: [], inputType: 'input' },
        { props: ['production_date'], placeholder: ['生产时间', '生产时间'], options: [], inputType: 'datePick' }
      ],
      searchParams: {
        keywords: '',
        device_sncode: '',
        production_batch: '',
        hardware_version: '',
        production_date: ''
      },
      tableOptList: [
        { text: '新增', icon: 'plus', key: 'addbtn' },
        { text: '删除', icon: 'close', disabled: true, key: 'batchDel' },
        { text: '导出', icon: 'download', handle: this.handleExport, key: 'export' }
      ],
      rowOptList: [
        { text: '修改', handle: (record) => this.$refs.table.toEdit(record), key: 'edit' },
        { text: '删除', handle: (record) => this.$refs.table.showDeleteConfirm(record), key: 'delete' }
      ],
      columns: [
        { title: '产品名称', dataIndex: 'product_name', align: 'left', width: '' },
        { title: '产品型号', dataIndex: 'type', align: 'left', width: '' },
        { title: '设备编码', dataIndex: 'device_sncode', align: 'left', width: '' },
        { title: '生产批次', dataIndex: 'production_batch', align: 'left', width: '' },
        { title: '硬件版本', dataIndex: 'hardware_version', align: 'left', width: '' },
        { title: '使用情况', dataIndex: 'is_used', align: 'left', width: '' },
        { title: '生产时间', dataIndex: 'production_time', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      listApi: {
        url: '/basis_info',
        resHandle: this.resHandle, // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addDevice',
        title: '修改设备'
      },
      deleteParam: {
        url: '/basis_info/del/',
        param: { pk_key: 'basic_id', pk_val: '' },
        title: '设备基础数据',
        key: 'product_name'
      }
    };
  },
  mounted () {
  },
  methods: {
    /* 导出设备 */
    handleExport (ids) {
      this.searchParams.basic_ids = ids.join(',');
      this.$get({
        url: '/basis_info/export',
        params: this.searchParams,
        config: { responseType: 'blob' }
      }).catch((res) => {
        let blob = new Blob([res.data], {type: res.headers['content-type']});
        let URL = window.URL || window.webkitURL;
        let objectUrl = URL.createObjectURL(blob);

        let a = document.createElement('a');
        if (typeof a.download === 'undefined') { // safari doesn't support this yet
          window.location = objectUrl;
        } else {
          a.href = objectUrl;
          a.download = 'file.xlsx';
          document.body.appendChild(a);
          a.click();
          a.remove();
        }
      });
    },
    resHandle (res) {
      res.forEach((ele) => {
        ele.is_used = ele.is_used === 1 ? '已使用' : '未使用';
      });
      return res;
    },
    searchHandle (selectData) {
      // return selectData;
    }
  }
};
</script>
